import api from "@/api";
import { AxiosResponse } from "axios";

export interface ReleaseResponse {
  /** Ids of the seats the user still holds on the event. */
  seats: string[];
  /** When the remaining holds end, null when none is left. */
  expires_at: string | null;
}

/** Releases one seat the user holds. */
export default async function releaseSeat(eventId: string, seatId: string): Promise<ReleaseResponse> {
  const response: AxiosResponse<ReleaseResponse> = await api.delete(`/api/events/${eventId}/reservation/seats/${seatId}`);
  return response.data;
}
